import React from "react";
import Select from "react-select";

import {
  TransformationEventType,
  TransformOperationOptionType,
  transformOperationOptions,
} from "../types";
import { themedSelectStyles } from "@/components/Dropdown/themedSelectStyles";
import { usePortalContainer } from "@/design-system/portalContainer";

interface Props {
  canUseSQLTransformation: boolean;
  transformationOption: TransformOperationOptionType | null;
  setTransformationOption: (
    option: TransformOperationOptionType | null,
  ) => void;
  isServerSideOnly: boolean;
  eventType: TransformationEventType;
}

export function AvailableTransformsSelector({
  canUseSQLTransformation,
  transformationOption,
  setTransformationOption,
  isServerSideOnly,
  eventType,
}: Props) {
  const portalContainer = usePortalContainer();
  return (
    <Select
      styles={themedSelectStyles<TransformOperationOptionType>({
        menuPortal: (base) => ({ ...base, zIndex: "var(--z-popover)" }),
      })}
      options={transformOperationOptions(
        canUseSQLTransformation,
        isServerSideOnly,
        eventType,
      )}
      value={transformationOption}
      onChange={setTransformationOption}
      menuPortalTarget={portalContainer}
      menuPosition="fixed"
    />
  );
}
